import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import Loading from '../Home/Share/Loading/Loading';
import BooksModal from './BooksModal';
import BooksSummery from './BooksSummery/BooksSummery';
// import { useQuery } from '@tanstack/react-query'
// import Loading from '../Home/Share/Loading/Loading';

const Books = () => {
    const id = useLoaderData();
    // loader: ({ params }) => fetch(`https://assignment-12-server-beige.vercel.app/category/${params.id}`);

    const { data: books = [], isLoading, refetch } = useQuery({
        queryKey: ['books'],
        queryFn: async () => {
            const res = await fetch(`https://assignment-12-server-beige.vercel.app/category/${id}`)
            const data = await res.json();
            return data;
        }
    })

    if (isLoading) {
        return <Loading></Loading>
    }

    return (

        <div>
            <h1 className='text-4xl text-center mt-4 font-semibold'>Choose your Books</h1>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 my-6 '>
                {
                    books.map(book => <BooksSummery book={book} key={book._id} refetch={refetch} ></BooksSummery>)
                }
            </div>

        </div>
    );
};

export default Books;